import * as i0 from '@angular/core';
import { InjectionToken, EventEmitter, Injectable, Inject, RendererFactory2, Directive, Renderer2, ElementRef, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i3 from '@angular/common';
import { DOCUMENT } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
const YM_CONFIG = new InjectionToken('ngx-metrika Config');

/** @dynamic */
class NgxMetrikaService {
    constructor(ymConfig, router, rendererFactory, document) {
        this.router = router;
        this.document = document;
        this.defaultConfig = {
            id: 0,
            triggerEvent: true,
            trackPageViews: true,
        };
        this.debug = false;
        this.hit = new EventEmitter();
        this.reachGoal = new BehaviorSubject({ target: 'test' });
        this.renderer = rendererFactory.createRenderer(null, null);
        if (ymConfig && ymConfig.id) {
            this.configure(ymConfig);
        }
    }
    static getCounterNameById(id) {
        return `yaCounter${id}`;
    }
    static getCounterById(id) {
        return window[NgxMetrikaService.getCounterNameById(id)];
    }
    configure(config) {
        config = Object.assign({}, this.defaultConfig, config);
        this.config = config;
        this.insertMetrika(config);
        this.checkCounter(config.id)
            .then(() => {
            this.hit.subscribe((y) => {
                this.onHit(this.router.url, y.hitOptions);
            });
            this.reachGoal.subscribe((y) => {
                this.onReachGoal(y.target, y.options);
            });
        });
        if (config.trackPageViews) {
            this.router.events.pipe(filter(event => event instanceof NavigationEnd), tap(() => {
                const options = {
                    url: this.router.url
                };
                this.hit.emit(options);
                this.previousUrl = this.router.url;
            })).subscribe();
        }
    }
    onHit(url, options) {
        try {
            const defaults = {
                referer: this.previousUrl
            };
            if (this.debug) {
                console.log('Hit:', url, defaults, options);
            }
            const ya = NgxMetrikaService.getCounterById(this.config.id);
            if (typeof ya !== 'undefined') {
                const optionsNew = Object.assign(defaults, options);
                if (this.debug) {
                    console.log('Hit:', url, optionsNew);
                }
                ya.hit(url, optionsNew);
            }
        }
        catch (err) {
            console.error('Yandex Metrika hit error', err);
        }
    }
    onReachGoal(type, options = {}) {
        try {
            const ya = NgxMetrikaService.getCounterById(this.config.id);
            if (typeof ya !== 'undefined') {
                if (this.debug) {
                    console.log('onReachGoal:', type, options);
                }
                ya.reachGoal(type, options.params, options.callback, options.ctx);
            }
        }
        catch (error) {
            console.error('error', error);
            console.warn(`'Event with type [${type}] can\'t be fired because counter is still loading'`);
        }
    }
    insertMetrika(config) {
        const name = 'yandex_metrika_callbacks2';
        window[name] = window[name] || [];
        window[name].push(() => {
            try {
                const a = NgxMetrikaService.getCounterNameById(config.id);
                window[a] = new Ya.Metrika2(config);
            }
            catch (e) {
            }
        });
        const head = this.document.getElementsByTagName('head')[0];
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://mc.yandex.ru/metrika/tag.js';
        const insetScriptTag = () => head.appendChild(s);
        if (window.opera === '[object Opera]') {
            this.document.addEventListener('DOMContentLoaded', insetScriptTag, false);
        }
        else {
            insetScriptTag();
        }
        return name;
    }
    checkCounter(id) {
        const that = this;
        return new Promise((resolve) => {
            const counterName = `yacounter${id}inited`;
            that.renderer.listen('document', counterName, () => {
                resolve({});
            });
        });
    }
}
NgxMetrikaService.ɵfac = function NgxMetrikaService_Factory(t) { return new (t || NgxMetrikaService)(ɵngcc0.ɵɵinject(YM_CONFIG), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(DOCUMENT)); };
NgxMetrikaService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NgxMetrikaService_Factory() { return new NgxMetrikaService(i0.ɵɵinject(YM_CONFIG), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i3.DOCUMENT)); }, token: NgxMetrikaService, providedIn: "root" });
NgxMetrikaService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [YM_CONFIG,] }] },
    { type: Router },
    { type: RendererFactory2 },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMetrikaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [YM_CONFIG]
            }] }, { type: ɵngcc1.Router }, { type: ɵngcc0.RendererFactory2 }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class NgxMetrikaGoalDirective {
    constructor(ym, renderer, el) {
        this.ym = ym;
        this.renderer = renderer;
        this.el = el;
    }
    ngAfterViewInit() {
        try {
            this.renderer.listen(this.el.nativeElement, this.trackOn, () => {
                const goalOptions = {
                    target: this.target || this.trackOn,
                    options: Object.assign({ callback: this.callback }, this.params)
                };
                this.ym.reachGoal.next(goalOptions);
            });
        }
        catch (err) {
            console.error(err);
        }
    }
}
NgxMetrikaGoalDirective.ɵfac = function NgxMetrikaGoalDirective_Factory(t) { return new (t || NgxMetrikaGoalDirective)(ɵngcc0.ɵɵdirectiveInject(NgxMetrikaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxMetrikaGoalDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMetrikaGoalDirective, selectors: [["", "ymGoal", ""]], inputs: { trackOn: "trackOn", target: "target", params: "params", callback: "callback" } });
NgxMetrikaGoalDirective.ctorParameters = () => [
    { type: NgxMetrikaService },
    { type: Renderer2 },
    { type: ElementRef }
];
NgxMetrikaGoalDirective.propDecorators = {
    trackOn: [{ type: Input }],
    target: [{ type: Input }],
    params: [{ type: Input }],
    callback: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMetrikaGoalDirective, [{
        type: Directive,
        args: [{
                selector: '[ymGoal]'
            }]
    }], function () { return [{ type: NgxMetrikaService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { trackOn: [{
            type: Input
        }], target: [{
            type: Input
        }], params: [{
            type: Input
        }], callback: [{
            type: Input
        }] }); })();

class NgxMetrikaModule {
    static forRoot(config) {
        return {
            ngModule: NgxMetrikaModule,
            providers: [
                NgxMetrikaService,
                { provide: YM_CONFIG, useValue: config }
            ]
        };
    }
}
NgxMetrikaModule.ɵfac = function NgxMetrikaModule_Factory(t) { return new (t || NgxMetrikaModule)(); };
NgxMetrikaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxMetrikaModule });
NgxMetrikaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMetrikaModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxMetrikaGoalDirective],
                exports: [NgxMetrikaGoalDirective],
                imports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxMetrikaModule, { declarations: [NgxMetrikaGoalDirective], exports: [NgxMetrikaGoalDirective] }); })();

/*
 * Public API Surface of ngx-metrika
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxMetrikaGoalDirective, NgxMetrikaModule, NgxMetrikaService, YM_CONFIG };

//# sourceMappingURL=kolkov-ngx-metrika.js.map